const AboutWhatDataED3NCollects = {
    title: "What Data ED3N Collects",
    lastUpdated: "September 4, 2025", // Set manually
    content: `Data provided to ED3N is maintained and stored in Azure Cloud in compliance with CDC's security policies and procedures and consistent with applicable law. De-identified biochemical analyte data is passed through ED3N via an API to Mayo's CLIR platform in order to provide CLIR-generated risk scores.`
};

export default AboutWhatDataED3NCollects;
